import { ContinueShoppingData, CardItem, TrackingItem, PreparedData } from './types';
import { SEE_ALL_THRESHOLD, MAX_PRODUCTS_DISPLAY } from './constants';

export const mapCardItemToTrackingItem = (article: CardItem): TrackingItem => ({
    sku: article.sku,
    brandCode: article.brand,
    campaignIdentifier: article.campaign_identifier,
    price: article.price,
    specialPrice: article.special_price,
    stockStatus: article.stock_status,
    plusEarlyAccess: article.plus_early_access,
    sustainable: article.sustainable,
    categoryId: null,
    simples: [],
});

export const prepareContinueShoppingData = (data: ContinueShoppingData): PreparedData => {
    const allCardItems = data.flatMap(category => category.configs);
    const trackingItems = allCardItems.map(mapCardItemToTrackingItem);

    const panelData = data.map(category => {
        const configsLength = category.configs.length;
        const shouldShowSeeAll = configsLength >= SEE_ALL_THRESHOLD;
        const categoriesList = category.configs.slice(0, MAX_PRODUCTS_DISPLAY);

        return {
            category,
            shouldShowSeeAll,
            categoriesList,
        };
    });

    return {
        panelData,
        allCardItems,
        trackingItems,
    };
};
